module.exports = __webpack_public_path__ + "static/media/fhir.862debb9.png";